module.exports = __webpack_public_path__ + "img/family-2.64ddd75f.jpg";